<div class="content">
  <button type="button" mat-icon-button class="close-button bg-transparent" mat-dialog-close>
    <mat-icon aria-hidden="false">close</mat-icon>
  </button>
  <div class="text-center mat-dialog-title">Bejelentkezés</div>
  <form [formGroup]="loginForm" class="flex-column flex-center" (ngSubmit)="login()">
    <mat-label>Felhasználónév</mat-label>
    <mat-form-field class="mb-2" appearance="outline">
      <input matInput type="text" formControlName="username" />
    </mat-form-field>
    <mat-label>Jelszó</mat-label>
    <mat-form-field class="mb-4" appearance="outline">
      <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" />
      <button
        mat-icon-button type="button" matSuffix
        (click)="hide = !hide"
        [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hide">
        <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    </mat-form-field>
    <button mat-flat-button type="submit" color="primary" class="mb-2">Bejelentkezés</button>
    <button mat-flat-button type="button" mat-dialog-close class="mb-2">Mégsem</button>
  </form>
  <mat-progress-spinner *ngIf="loading" mode="indeterminate"></mat-progress-spinner>
</div>
